import { Fragment, FunctionComponent, h } from 'preact';
import { Text } from 'preact-i18n';
import { AmPaxAmount, AmPaxType, NBSP, Properties } from '../../../../common';
import { canAddRemoveAmPaxAmount } from '../../paxAmountUtils';
import { AmountField } from '../AmountField/AmountField';
import { FinText } from '../../../../i18n';

export interface AmPaxSelectionProps extends Properties {
  type: AmPaxType;
  autofocus?: boolean;
  paxAmount: AmPaxAmount;
  maxRemainingPaxes: { [key in AmPaxType]: number };
  onIncrease: (type: AmPaxType) => void;
  onDecrease: (type: AmPaxType) => void;
  classes?: string;
}

export const AmPaxSelection: FunctionComponent<AmPaxSelectionProps> = ({
  type,
  autofocus,
  classes,
  paxAmount,
  maxRemainingPaxes,
  onIncrease,
  onDecrease,
}: AmPaxSelectionProps) => {
  const isChild = type === 'children';
  const amount: number = paxAmount[type];
  const { canAdd, canRemove } = canAddRemoveAmPaxAmount(type, paxAmount, maxRemainingPaxes);
  const increase = (): void => onIncrease(type);
  const decrease = (): void => onDecrease(type);

  const fieldLabel = (
    <Fragment>
      <span class="capitalize">
        <Text id={`paxAmount.${type}`} plural={amount} />
      </span>
      {isChild && [NBSP, <FinText key={1} id="aurinkomatkat.paxAmount.childAgeRange" />]}
    </Fragment>
  );

  return (
    <AmountField
      label={fieldLabel}
      helperText={isChild && <FinText id="aurinkomatkat.paxAmount.childAgeRule" />}
      amount={amount}
      onIncrease={increase}
      onDecrease={decrease}
      classes={classes}
      disableIncrease={!canAdd}
      disableDecrease={!canRemove}
      increaseAriaLabel={<FinText id={`paxAmountModal.add.${type}`} />}
      decreaseAriaLabel={<FinText id={`paxAmountModal.remove.${type}`} />}
      testIdSuffix={type}
      autofocus={autofocus}
    />
  );
};
